import { useState } from 'react';

export const useDialog = <DialogKey extends string>(
  initialState: Record<DialogKey, boolean>,
) => {
  const [dialogsState, setDialogsState] =
    useState<Record<DialogKey, boolean>>(initialState);

  const handleOpen = (dialogKey: DialogKey) => () => {
    setDialogsState((prev) => ({ ...prev, [dialogKey]: true }));
  };

  const handleClose = (dialogKey: DialogKey) => () => {
    setDialogsState((prev) => ({ ...prev, [dialogKey]: false }));
  };

  return {
    dialogsState,
    onOpen: handleOpen,
    onClose: handleClose,
  };
};
